import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }

import Menu from "@/components/Menu.vue";
import footerComp from "@/components/footer.vue";
import FixedBtn from "@/components/fixedBtn.vue";
import {
  ref,
  onMounted,
  onUnmounted,
  getCurrentInstance,
  computed,
  nextTick,
} from "vue";
import GoTop from "@/components/goTop.vue";
import {useRoute} from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
console.log('route-------',route)
const { proxy } = getCurrentInstance() as any;

const isLargeScreen = ref(window.innerWidth >= 960);
const goTopRef = ref(0);

const updateScreenSize = () => {
  isLargeScreen.value = window.innerWidth >= 960;
};
const navHeight = ref(0);

// 根据当前路由判断是否需要全屏宽度
const isFullWidth = computed(() => {
  // 通过路由meta配置决定是否启用全屏
  return route.meta.fullWidth === true;
});
onUnmounted(() => {
  window.removeEventListener("resize", updateScreenSize);
  window.removeEventListener("scroll", handleScroll);
});

const footerRef = ref<HTMLElement>();
const menuRef = ref<HTMLElement>();
const myRef = ref<HTMLElement>();

// 中间主体部分高度
const mainHeight = ref<number>(0);

const isMin = ref(false);

// 屏幕宽度
const screenWidth = ref(0);

// 设置中间高度，保证页脚在页面底部
const setMainHeight = () => {
  // 获取导航栏高度
  navHeight.value = document.getElementById("menuId")?.clientHeight;

  // 获取底部页脚高度
  let footerHeight = document.getElementById("footerId")?.clientHeight;

  console.log(navHeight, footerHeight);

  // 获取浏览器高度document.documentElement.clientHeight
  let mHeight = document.documentElement.clientHeight - (footerHeight || 0);
  mainHeight.value = mHeight;
  console.log('mainHeight', mainHeight.value);
};

onMounted(() => {
  // 设置中间高度，保证页脚在页面底部
  setMainHeight();

  window.addEventListener("resize", updateScreenSize);

  //监听页面滚动事件
  window.addEventListener("scroll", handleScroll);
});

//处理滚动事件
const handleScroll = (event) => {
  //展示回到顶部按钮
  if (window.scrollY > 1000) {
    goTopRef.value?.showTop();
  } else {
    goTopRef.value?.hideTop();
  }
};

/**
 * 判断是否是首页
 */
const isHome = ()=>{
  return route.name === 'home'
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "mainPage",
        style: _normalizeStyle({background: isHome() ? 'linear-gradient(180deg, #ebf1f5 0%, #f7f8fa 100%)' : 'none'})
      }, [
        _createVNode(Menu, {
          ref_key: "menuRef",
          ref: menuRef,
          id: "menuId",
          isHome: isHome()
        }, null, 8, ["isHome"]),
        _createElementVNode("div", {
          class: "mainBox",
          id: "mainBox",
          ref_key: "myRef",
          ref: myRef,
          style: _normalizeStyle({
          padding:0,
          paddingTop: navHeight.value + 'px',
          minHeight: mainHeight.value + 'px',
          maxWidth: isFullWidth.value ? 'none' : '1200px',
        })
        }, [
          _createVNode(_component_router_view, { isFullWidth: isFullWidth.value }, null, 8, ["isFullWidth"])
        ], 4),
        _createVNode(footerComp, {
          id: "footerId",
          ref_key: "footerRef",
          ref: footerRef
        }, null, 512)
      ], 4)
    ]),
    _createVNode(GoTop, {
      ref_key: "goTopRef",
      ref: goTopRef
    }, null, 512),
    _createVNode(FixedBtn, { isFixed: true })
  ], 64))
}
}

})